import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-already-running-quiz-dialog',
  templateUrl: './already-running-quiz-dialog.component.html',
  styleUrls: ['./already-running-quiz-dialog.component.scss']
})
export class AlreadyRunningQuizDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
